import { useTranslation } from "react-i18next";
import {
	Grid,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
	Tooltip,
	Typography,
} from "@material-ui/core";

// Styles
import QuestionnaireStyle from "../../assets/styles/materialUI/questionnaire/QuestionnaireStyle";

// Providers
import { useLanguage } from "../../contexts/languageContext";

const SessionValidationPopover = ({ sessionExpirationCounter, showSessionExpiration, onContinue, onLogout }) => {
	const { t } = useTranslation();
	const classes = QuestionnaireStyle();
	const { direction } = useLanguage();

	const resetSession = () => {
		if (onContinue) {
			onContinue();
		}
	};

	const logout = () => {
		if (onLogout) {
			onLogout();
		}
	};

	return (
		<Grid>
			<Dialog
				open={showSessionExpiration}
				onClose={logout}
				aria-labelledby="session-expiration-title"
				dir={direction}
				maxWidth="sm"
				fullWidth
			>
				<DialogTitle id="session-expiration-title" className={classes.sessionDialogTitle}>
					{t("session.title")}
				</DialogTitle>
				<DialogContent>
					<Grid className={classes.sessionExpiredGrid}>
						<Typography color="secondary">
							{t("session.message", { seconds: sessionExpirationCounter })}
						</Typography>
					</Grid>
				</DialogContent>
				<DialogActions className={classes.sessionActionContainer}>
					<Button
						onClick={logout}
						variant="contained"
						color="primary"
						className={classes.sessionLogoutButton}
					>
						{t("navbar.logout")}
					</Button>
					<Button
						variant="contained"
						className={classes.sessionExpiredButton}
						onClick={resetSession}
						autoFocus
					>
						<Tooltip title={t("session.extend")}>
							<span>{t("common.buttons.continue")}</span>
						</Tooltip>
					</Button>
				</DialogActions>
			</Dialog>
		</Grid>
	);
};

export default SessionValidationPopover;
